import { Skeleton } from '@/common/components/ui/skeleton';
import { TableBody, TableCell, TableRow } from '@/common/components/ui/table';
interface RenewalListSkeletonProps {
  rowCount: number;
}
export const RenewalListSkeleton = ({ rowCount }: RenewalListSkeletonProps) => {
  return (
    <TableBody>
      {Array.from({ length: rowCount }).map((_, index) => (
        <TableRow key={`skeleton-${rowCount}-${index}`}>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-24 bg-muted-foreground/20" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-32 bg-muted-foreground/20" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="border-r">
            <Skeleton className="h-4 w-24 bg-muted-foreground/20" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-40 bg-muted-foreground/20" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-28 bg-muted-foreground/20" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-32 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="border-r">
            <Skeleton className="h-4 w-28 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="text-right">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell className="text-right">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell className="text-right border-r">
            <Skeleton className="h-4 w-16 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell className="text-center">
            <Skeleton className="h-4 w-8 bg-muted-foreground/20 mx-auto" />
          </TableCell>
          <TableCell className="text-center border-r">
            <Skeleton className="h-4 w-8 bg-muted-foreground/20 mx-auto" />
          </TableCell>
          <TableCell className="text-right">
            <Skeleton className="h-4 w-16 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell className="text-right">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell className="text-right">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};
